export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; {new Date().getFullYear()} All Rights Reserved.{' '}
            <a href='http://' rel='nofollow'>
            Naassh Ltd
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
